import { Text, Flex } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'

import btnUpPng from 'assets/vvsgotchi/moleDashGame/btn_up.png'
import btnDownPng from 'assets/vvsgotchi/moleDashGame/btn_down.png'

export const MoleDashGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb={3} color="black" fontWeight="600">
        {t('Dash with miner mole and aviod all the obstacles')}
      </Text>
      <Flex alignItems="center" mb={3} gap="12px">
        <PixelatedImage src={btnUpPng} width="57px" />
        <Text color="darkGrey" mb={2}>
          {t('Jump to avoid the obstacles on the ground.')}
        </Text>
      </Flex>
      <Flex alignItems="center" mb={3} gap="12px">
        <PixelatedImage src={btnDownPng} width="57px" />
        <Text color="darkGrey" mb={2}>
          {t('Dodge to avoid the obstacles in the air.')}
        </Text>
      </Flex>
    </>
  )
}
